import React, { useEffect } from 'react';
import PropTypes from 'prop-types';
import Dialog from '@material-ui/core/Dialog';
import DialogTitle from '@material-ui/core/DialogTitle';
import DialogContent from '@material-ui/core/DialogContent';
import { withStyles } from '@material-ui/core/styles';
import Button from '../../../components/Button';
import ReactCrop from 'react-image-crop';
import 'react-image-crop/dist/ReactCrop.css';

function CropModal(props) {
  const {
    open,
    onClose,
    image,
    crop,
    onImageLoaded,
    onCropChange,
    onDone,

    classes: {
      modal,
      modalContent,
      title,
      button,
      span,
      cropFig,
    },
  } = props;

  useEffect(() => {
    const html = document.documentElement;
    const body = document.body;

    if (open) {
      html.style.overflow = 'hidden';
      body.style.overflow = 'hidden';
    } else {
      html.style.overflow = '';
      body.style.overflow = '';
    }

    return () => {
      html.style.overflow = '';
      body.style.overflow = '';
    };
  }, [open]);

  return (
    <Dialog
      maxWidth={'md'}
      open={open}
      // disableBackdropClick
      onClose={onClose}
      classes={{ paper: modal }}
    >

      <DialogTitle className={title}>Crop Your Picture</DialogTitle>

      <DialogContent classes={{ root: modalContent }}>

        <ReactCrop className={cropFig}
          src={image.dataUrl}
          crop={crop}
          onImageLoaded={onImageLoaded}
          onChange={onCropChange}
        />

      </DialogContent>

      <span className={span}>
        <Button
          onClick={onDone}
          variant="contained"
          color="primary"
          className={button}
          disabledDuringOnClick
        > Done
        </Button>

        <Button
          onClick={onClose}
          variant="contained"
          color="primary"
          className={button}
        > Cancel
        </Button>
      </span>
    </Dialog>
  );
}

CropModal.propTypes = {
  open: PropTypes.func.isRequired,
  onClose: PropTypes.func.isRequired,
};

const styles = () => ({
  modal: {
    maxHeight: '700px',
  },
  modalContent: {
    overflow: 'visible',
    padding: '0px',
  },
  title: {
    marginTop: '10px',
    marginLeft: 'auto',
    marginRight: 'auto',
    padding: '5px',
  },
  button: {
    width: '100px',
    margin: '10px',
  },
  span: {
    margin: 'auto',
    marginTop: '0px',
  },
  cropFig: {
    maxHeight: '600px',
    maxWidth: '600px',
    marginLeft: '10px',
    marginRight: '10px',
    marginBottom: '-3px',
  },
});

export default withStyles(styles)(CropModal);
